module.exports = __webpack_public_path__ + "static/media/uk.f656668b.svg";